import React, { lazy, Suspense } from "react";
import { Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import Loading from "../components/Loading";
import Sample from "../View/sample/Sample";
import SimpaleTable from "../View/sample/SimpaleTable";

import PublicRoute from "./PublicRoute";
import StepGuardRoute from "./stepGuardRoute";
import RegistrationAwarePublicRoute from "./RegistrationAwarePublicRoute";
import RegistrationAwarePrivateRoute from "./RegistrationAwarePrivateRoute";
import Login from "../View/Login/Login";
import Dashboard from "../View/Dashboard/Dashboard";

import Terms_and_condition from "../View/Terms _and_condition/Terms_and_condition";
import Basic_info from "../View/Basic_info/Basic_info";

import Agency_Rent from "../View/Agency_Rent/Agency_Rent";

//import Renters_info from "../View/Renters_info/Renters_info";
import Propertywatch1 from "../View/PropertyWatch/Propertywatch1";
import Renters_list from "../View/Renters_list/Renters_list";
import RegistartionTenantProfile from "../View/Renters_list/TenantProfile"
import New_registration_otp_verification from "../View/Registration/New_registration_otp_verification";
import Property_owner_new_registration1 from "../View/Registration/Property_owner_new_registration1";
import New_registration_for_users from "../View/Registration/New_registration_for_users";
import Find_Property_Register from "../View/Registration/Find_property_registration";

import New_registration_otp from "../View/Registration/New_registration_otp";
import Non_registered_user from "../View/Registration/Non_registered_user";
// or
import Non_registered_user1 from "../View/Registration/Non_registered_user1";

import Register_renters_list from "../View/Registration/Register_renters_list";

import Property_owner_new_registration from "../View/Registration/Property_owner_new_registration";
import Property_owner_free_register from "../View/Registration/Property_owner_free_register";

import AlreadySignedIn from "../View/AlreadySignIn/AlreadySignIn";

import Subscription from "../View/Subscription/Subscription";
import Subscription_history from "../View/Subscription/Subscription_history";

import Subscription_info from "../View/Subscription/Subscription_info";
import MyProfile from "../View/My_Profile/MyProfile";
import userNotification from "../View/UserNotification/userNotification";
import ChangePassword from "../View/ChangePassword/ChangePassword";
import ForgetPassword from "../View/ForgetPassword/ForgetPassword";
import VerifyOTP from "../View/ForgetPassword/VerifyOTP";
import ResetPassword from "../View/ResetPassword/ResetPassword";
import cardView from "../View/Card_view/cardView";

// import cardListView from "../View/Card_view/cardListView";
import List_view from "../View/List_view/List_view";
import propertyInfo from "../View/Property_info/propertyInfo";
import MapView1 from "../View/MapView-1/mapView1";
import ContactUs from "../View/ContactUs/ContactUs";
import PropertyInfoNon from "../View/Property_info(non-registered-user)/Property_info(non-registered)";
import PropertyInfo4 from "../View/Property-info4/PropertyInfo4";
import PropertyPreview from "../View/Property-info4/PropertyPreview";
import PorpertiesList from "../View/PropertiesList/propertiesLIst";

import RentalAggreement from "../View/RentalAggrement/index";
import ConfirmationCard from "../View/RentalAggrement/ConfirmationCard";

const Home = lazy(async () => await import("../View/Home/Home"));

const CMSPages = lazy(async () => await import("../View/CmsPage/index"));

// const theCompany = lazy(
//   async () => await import("../View/The-Company/theCompany")
// );

const PropertyListing = lazy(
  async () => await import("./../View/PropertyListing/Index")
);
const EditProfile = lazy(
  async () => await import("../View/EditProfile/EditProfile")
);
const FavouriteProperties = lazy(
  async () => await import("../View/FavouriteProperties/FavouriteProperties")
);

const Renters_list_edit_screen = lazy(
  async () =>
    await import("../View/Renters_list_edit_screen/Renters_list_edit_screen")
);
const EditRenterInfo = lazy(
  async () =>
    await import("../View/Renters_list_edit_screen/EditRenterInfo")
);
const Renters_list_edit_screen1 = lazy(
  async () =>
    await import("../View/Renters_list_edit_screen/Renters_list_edit_screen1")
);
const RenterUpdate = lazy(async () => await import("../View/Registration/RenterUpdate"))
const RenterListDetails = lazy(async () => await import("../View/Registration/RenterListDetails"))

const HiddenProperties = lazy(
  async () => await import("../View/HiddenProperties/HiddenProperties")
);
const ReportIncorrectDetails = lazy(
  async () =>
    await import("../View/ReportIncorrectDetails/ReportIncorrectDetails")
);
const WhishList = lazy(
  async () => await import("../View/CreateWhishlist/CreateWhishlist")
);
// const UdapteWhishList = lazy(
//   async () => await import("../View/CreateWhishlist/UpdateWhishlist")
// );
const MyWishlist = lazy(
  async () => await import("../View/MyWishlist/MyWishlist")
);
const PropertyWatch = lazy(
  async () => await import("../View/PropertyWatch/PropertyWatch")
);
const PropertiesWatch = lazy(
  async () => await import("../View/PropertyWatch/PropertiesWatch")
);

const ChatView = lazy(async () => await import("../View/ChatView/ChatView"));
const AppliedProperties = lazy(
  async () => await import("../View/AppliedProperty/AppliedProperties")
);

const PropertyOwnerSignup = lazy(
  async () => await import("../View/PropertyOwnerSignup/PropertyOwnerSignup")
);
const PropertyOwnerOtpVerification = lazy(
  async () =>
    await import("../View/PropertyOwnerSignup/PropertyOwnerOtpVerification")
);

const QuestionAnswer = lazy(
  async () => await import("../View/QuestionAnswer/QuestionAnswer")
);

const ChatInitialise = lazy(
  async () => await import("../View/ChatInitialise/ChatInitialise")
);
const NonLoggedChatView = lazy(
  async () => await import("../View/NonLoginChat/ChatView")
);

const ReportedProperties = lazy(async () => await import("../View/ReportedProperties/ReportedProperties"))
const TenantList = lazy(async () => await import("../View/TenantList/TenantList"))
const NotFound = lazy(async () => await import("../View/NotFound/NotFound"))

export default function AppRoutes() {
  const { currentStepIndex, steps, isInRegistration } = useSelector((state) => state.registration);

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        {/*<RegistrationAwarePublicRoute exact path="/properties-list" component={Sample} />*/}
        <StepGuardRoute
          path="/terms-and-condition"
          component={Terms_and_condition}
          registrationSteps={steps}
          currentStepIndex={currentStepIndex}
        />
        <StepGuardRoute
          path="/register-basic-info"
          component={Basic_info}
          registrationSteps={steps}
          currentStepIndex={currentStepIndex}
        />
        {/* <StepGuardRoute
          path="/register-property-watch"
          component={PropertiesWatch}
          registrationSteps={steps}
          currentStepIndex={currentStepIndex}
        /> */}
        <StepGuardRoute
          path="/register-rental-profile"
          component={Renters_list_edit_screen}
          registrationSteps={steps}
          currentStepIndex={currentStepIndex}
        />
        <StepGuardRoute
          path="/register-tenant-profile"
          component={RegistartionTenantProfile}
          registrationSteps={steps}
          currentStepIndex={currentStepIndex}
        />
        <RegistrationAwarePublicRoute exact path="/sample-properties" component={SimpaleTable} />
        <RegistrationAwarePublicRoute exact path="/login" component={Login} />
        <RegistrationAwarePrivateRoute exact path="/change-password" component={ChangePassword} />
        <RegistrationAwarePublicRoute exact path="/forget-password" component={ForgetPassword} />
        <RegistrationAwarePublicRoute exact path="/verify-otp" component={VerifyOTP} />
        <RegistrationAwarePublicRoute exact path="/reset-password" component={ResetPassword} />
        {/* <RegistrationAwarePrivateRoute
        exact
        path="/terms-and-condition"
        component={Terms_and_condition}
      /> */}
        {/* <RegistrationAwarePrivateRoute exact path="/basic-info" component={Basic_info} />  */}
      // <RegistrationAwarePrivateRoute exact path="/property-watch" component={Propertywatch1} />
        <RegistrationAwarePrivateRoute exact path="/tenant-profile" component={Renters_list} />
        <RegistrationAwarePrivateRoute exact path="/tenant-list" component={TenantList} />
        <RegistrationAwarePublicRoute exact path="/agency-rent" component={Agency_Rent} />
        <RegistrationAwarePublicRoute
          exact
          path="/new-registration"
          component={Property_owner_new_registration1}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/registration/register-renters-list"
          component={Register_renters_list}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/new-registration-otp-verification"
          component={New_registration_otp_verification}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/registration/type"
          component={New_registration_for_users}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/registration/find-property"
          component={Find_Property_Register}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/registration/non-registered-user"
          component={Non_registered_user}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/renters/details/:id"
          component={RenterListDetails}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/renters/update/:id"
          component={RenterUpdate}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/subscribe-in-renter-list/non-registered-user"
          component={Non_registered_user1}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/landlords/register-type"
          component={Property_owner_new_registration}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/landlords/register-property-free"
          component={Property_owner_free_register}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/access-by-otp"
          component={New_registration_otp}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/already-sign-in"
          component={AlreadySignedIn}
        />
        <RegistrationAwarePrivateRoute exact path="/subscription" component={Subscription} />
        <RegistrationAwarePrivateRoute
          exact
          path="/subscription-history"
          component={Subscription_history}
        />

        <RegistrationAwarePrivateRoute
          exact
          path="/subscription-info"
          component={Subscription_info}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/my-profile"
          component={MyProfile}
        // auth={localStorage.getItem("token")}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/dashboard"
          component={Dashboard}
        // auth={localStorage.getItem("token")}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/edit-profile"
          component={EditProfile}
        // auth={localStorage.getItem("token")}
        />
        <RegistrationAwarePrivateRoute exact path="/notification" component={userNotification} />
        <RegistrationAwarePublicRoute exact path="/properties/:key?/:value?" component={cardView} />
        {/* <RegistrationAwarePublicRoute
        exact
        path="/properties/properties-list"
        component={cardListView}
  />*/}
        <RegistrationAwarePrivateRoute exact path="/properties-list" component={PorpertiesList} />
        <RegistrationAwarePrivateRoute exact path="/list-view" component={List_view} />
        <RegistrationAwarePrivateRoute exact path="/property-info" component={propertyInfo} />
        <RegistrationAwarePrivateRoute
          exact
          path="/hidden-properties"
          component={HiddenProperties}
        //  auth={localStorage.getItem("token")}
        />
        {/* <RegistrationAwarePublicRoute exact path="/create-wishlist" component={WhishList} /> */}
        {/* <RegistrationAwarePrivateRoute
        exact
        path="/update-wishlist/:id"
        component={UdapteWhishList}
      /> */}
        {/* <RegistrationAwarePrivateRoute exact path="/my-wishlist" component={MyWishlist} />  */}
        <RegistrationAwarePrivateRoute
          exact
          path="/report-property/:id"
          component={ReportIncorrectDetails}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/favourite-properties"
          component={FavouriteProperties}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/applied-properties"
          component={AppliedProperties}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/"
          component={Home}
        // render={(props) => <Home {...props} />}
        />

        <RegistrationAwarePrivateRoute exact path="/map-view" component={PropertyListing} />
        <RegistrationAwarePrivateRoute
          exact
          path="/property-watch-change-search-criteria"
          component={PropertyWatch}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/property-watch"
          component={PropertiesWatch}
        />
        <RegistrationAwarePrivateRoute exact path="/chat-view/:id?" component={ChatView} />
        <RegistrationAwarePublicRoute exact path="/properties-map" component={MapView1} />
        <RegistrationAwarePublicRoute exact path="/contact-us" component={ContactUs} />

        <RegistrationAwarePrivateRoute
          exact
          path="/update-renter-info"
          component={EditRenterInfo}
        />
        <RegistrationAwarePrivateRoute
          exact
          path="/renters-info"
          component={Renters_list_edit_screen1}
        />
        <RegistrationAwarePrivateRoute exact path="/reported-properties" component={ReportedProperties} />
        <RegistrationAwarePublicRoute
          exact
          path="/property-info-non-registered"
          component={PropertyInfoNon}
        />
        <RegistrationAwarePublicRoute exact path="/property-details/:id" component={PropertyInfo4} />

        <RegistrationAwarePublicRoute
          exact
          path="/property/preview/:id/:req?"
          component={PropertyPreview}
        />
        <RegistrationAwarePublicRoute exact path="/terms-and-conditions" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/landlord-service-available" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/tenant-service" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/renters-service" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/the-rental-market" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/landlord-service" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/the-company" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/staff" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/location-opening-hours" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/price-list" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/privacy-policy" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/services-available" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/housing-benefit" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/how-does-the-rental-list-work" component={CMSPages} />

        <RegistrationAwarePublicRoute exact path="/what-is-renter-info" component={CMSPages} />
        <RegistrationAwarePublicRoute exact path="/links" component={CMSPages} />
        {/* <RegistrationAwarePublicRoute
        exact
        path="/here-you-will-find-an-apartment-for-rent"
        component={Find_Property_Register}
      /> */}

        {/* <RegistrationAwarePublicRoute exact path="/question-answer" component={CMSPages} /> */}
        <RegistrationAwarePublicRoute exact path="/confirm/:token/:id" component={RentalAggreement} />
        <RegistrationAwarePublicRoute exact path="/property-success" component={ConfirmationCard} />
        <RegistrationAwarePublicRoute
          exact
          path="/property-owner-signup"
          component={PropertyOwnerSignup}
        />
        <RegistrationAwarePublicRoute
          exact
          path="/property-owner-otp-verification"
          component={PropertyOwnerOtpVerification}
        />
        <RegistrationAwarePublicRoute exact path="/question-answer" component={QuestionAnswer} />
        <RegistrationAwarePublicRoute exact path="/chat-initialize" component={ChatInitialise} />
        <RegistrationAwarePublicRoute exact path="/non-login-chat" component={NonLoggedChatView} />
        <RegistrationAwarePublicRoute component={NotFound} />

      </Switch>
    </Suspense>
  );
}
